<template>
    <div class="light-header">
        <img src="../../images/logo.svg" class="light-header-logo">

        <router-link :to="{name: 'dashboard'}" class="close-link">
            <!-- Generator: Adobe Illustrator 24.1.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 height="24px" width="24px" style="enable-background:new 0 0 24 24;" xml:space="preserve">

                    <g id="Close">
                        <polygon id="Fill-2" class="st0" points="18,7.4 16.6,6 12,10.6 7.4,6 6,7.4 10.6,12 6,16.6 7.4,18 12,13.4 16.6,18 18,16.6
                            13.4,12 	"/>
                         </g>
                    </svg>

        </router-link>
    </div>
</template>

<script>
    export default {
        name: "LightHeader"
    }
</script>

<style lang="scss" scoped>
    .light-header {
        padding: 20px 0 5px 0;
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #E9EAEC;
    }

    .light-header-logo {
        height: 24px;
    }

    .close-link {
        cursor: pointer;
        height: 24px;
        float: right;
        margin: 0 10px 0 0;

        .st0 {
            fill: #CCD2D4;
        }
    }
</style>
